// eslint-disable-next-line import/prefer-default-export
export const FALLBACK_USER_PERMISSIONS = [
  {
    id: 1,
    name: "create_deals",
    category: "pipeline/Assets",
  },
  {
    id: 2,
    name: "read_deals",
    category: "pipeline/Assets",
  },
  {
    id: 3,
    name: "update_deals",
    category: "pipeline/Assets",
  },
  {
    id: 4,
    name: "delete_deals",
    category: "pipeline/Assets",
  },
  {
    id: 5,
    name: "view_dashboards",
    category: "dashboards",
  },
  {
    id: 27,
    name: "view_inbox",
    category: "inbox",
  },
];



// WEBPACK FOOTER //
// ./src/constants/fallbackData.js